const Shimmer = () =>{
    <div className="flex px-6">
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
        <div className="bg-gray-100 rounded-md w-64 md:w-[300px]">Loading...</div>
    </div>

}

export default Shimmer; 